export default __webpack_public_path__ + "static/media/Lambos.505e0951.jpg";